/* Bactera · the welcome gift on pages without the product page's scripts
   (the knowledge pages and the page 16S vs. shotgun sequencing, October
   2026), loaded by sections/vc-gift.liquid. The card, its tab, the address
   check and the way back from the sign-up are the product page's own
   (assets/vc-pd.js, section 6), copied unchanged except for two points:
   the card moves into a wrapper of its own at the end of the page, and the
   way back reads the section's setting instead of the product page's buy
   form (quantity 1). The card remembers what it remembers on the product
   page (vcGift:<code> in the browser), so a visitor sees it once per visit
   and not at all for a while after signing up, whichever page they meet it
   on. */
(function () {
  'use strict';

  if (window.__vcGiftLoaded) return;
  window.__vcGiftLoaded = true;

  /* the wrapper at the end of the page the card and its tab move into, so
     no section (each its own stacking context) can paint over them */
  function floatWrap(root) {
    var wrap = document.querySelector('.vc-float.vc--gift');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = root.className + ' vc-float';
      document.body.appendChild(wrap);
    }
    return wrap;
  }
  /* The theme marks an open drawer or modal on its overlay (painted, or
     aria-expanded), on the element itself (open), or by locking the page
     scroll; any of these counts. */
  function themeOverlays() {
    return Array.prototype.filter.call(document.querySelectorAll('overlay-element, .drawer, .x-modal'), function (el) { return !el.closest('.vc'); });
  }
  function overlayOpen(els) {
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.isConnected) continue;
      if (el.hasAttribute('open') || el.getAttribute('aria-expanded') === 'true') return true;
      if (el.tagName === 'OVERLAY-ELEMENT') {
        var cs = getComputedStyle(el);
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05) return true;
      }
    }
    return getComputedStyle(document.documentElement).overflowY === 'hidden' || getComputedStyle(document.body).overflowY === 'hidden';
  }

  /* The cart, for the buy buttons and the welcome gift when they open the
     theme's cart drawer. The drawer is the theme's own: it names its section
     on cart:bundled-sections, Shopify renders that section with the cart
     reply, and the theme's cart script repaints the drawer (and the cart
     count) from it when the update is published; show() then slides the
     drawer in, as the cart icon does. */
  function cartRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }
  function cartSections() {
    var list = [];
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: list } })); } catch (e) {}
    return list;
  }
  function cartPost(path, body) {
    return fetch(cartRoot() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || (j && j.status && j.message)) throw new Error((j && (j.description || j.message)) || ('cart ' + r.status));
        return j;
      });
    });
  }
  function cartGet() {
    return fetch(cartRoot() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function openDrawer(cart, source) {
    var t = window.theme;
    if (t && t.pubsub && t.pubsub.PUB_SUB_EVENTS && cart && cart.sections) {
      try { t.pubsub.publish(t.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: source || 'vc-buy', cart: cart }); } catch (e) {}
    }
    var drawer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') drawer.show();
    else document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
  }


  /* The welcome gift. The slim tab at the right edge shows from the start
     and opens the card. The card also opens by itself once the visitor has
     been on the page for the set time (unless a drawer of the theme is open
     just then), as long as it has not been open in this visit. It folds
     back into the tab, and a later page of the visit keeps the tab and does
     not pop up again. A sign-up keeps the gift away for a number of
     days. Card and tab move to the end of the page, where no section can
     hold them (in the theme editor too), so the tab stays at the edge of
     the screen all the way down.
     Sending is Shopify's own newsletter sign-up, left to run as on every
     Shopify form, so its spam protection (hCaptcha) adds its token unseen;
     the script only checks the address and points return_to at Shopify's
     cart link with the chosen quantity, the code and the address, which
     opens the checkout. Should the spam protection still be loading when
     the button is pressed, the form waits for it and then goes the same way.
     Should Shopify ask for its check ("I am not a robot") and send the
     visitor back to this page, the card opens again with the address.
     On a phone a heading that only just misses one line is set a touch
     smaller, so it fits on one line instead of leaving its last words on a
     line of their own.
     Shopify refuses an address whose domain cannot receive mail, and its
     answer then comes on a page of its own. So the address is checked
     before sending: a broken address gets the error note, a misspelt big
     provider or a wrong ending (gmial.com, gmx.dee) a suggestion to tap,
     and pressing the button once more sends the address as typed. Should
     Shopify still refuse one, the page comes back with the address and a
     note in the card, which opens again.
     In the theme editor the card opens while its block is selected. */
  var GIFT_BIG = ['gmail.com', 'googlemail.com', 'gmail.de', 'gmx.de', 'gmx.net', 'gmx.com', 'gmx.at', 'gmx.ch', 'web.de', 't-online.de', 'yahoo.com', 'yahoo.de', 'hotmail.com', 'hotmail.de', 'hotmail.at', 'hotmail.ch', 'outlook.com', 'outlook.de', 'outlook.at', 'live.com', 'live.de', 'live.at', 'msn.com', 'icloud.com', 'me.com', 'mac.com', 'aol.com', 'aol.de', 'freenet.de', 'posteo.de', 'mailbox.org', 'proton.me', 'protonmail.com', 'protonmail.ch', 'pm.me', 'arcor.de', 'online.de', 'email.de', 'mail.de', 'mail.com', 'vodafone.de', 'kabelmail.de', 'bluewin.ch'];
  var GIFT_ENDS = { con: 'com', cmo: 'com', comm: 'com', coom: 'com', cpm: 'com', vom: 'com', xom: 'com', ocm: 'com', cim: 'com', dee: 'de', dde: 'de', ed: 'de', dd: 'de', dr: 'de', dw: 'de', nte: 'net', ney: 'net', nett: 'net' };
  var GIFT_DOMAIN = /^(?=.{4,253}$)([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,24}$/;
  var GIFT_LOCAL = /^[^\s@<>()\[\],;:"\\]+$/;
  /* the number of typing slips between two words (a swap of neighbours
     counts as one) */
  function giftDist(a, b) {
    var m = a.length, n = b.length, d = [], i, j;
    for (i = 0; i <= m; i++) d[i] = [i];
    for (j = 0; j <= n; j++) d[0][j] = j;
    for (i = 1; i <= m; i++) {
      for (j = 1; j <= n; j++) {
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
    return d[m][n];
  }
  /* valid: the address is well formed; fix: a corrected address to offer
     (a big provider's domain within a slip or two, a known wrong ending
     mended, a comma or a doubled dot straightened), or null */
  function giftCheck(value) {
    var email = String(value || '').trim();
    var at = email.lastIndexOf('@');
    if (at < 1 || email.indexOf('@') !== at) return { valid: false, fix: null };
    var local = email.slice(0, at), dom = email.slice(at + 1).toLowerCase();
    var localOk = GIFT_LOCAL.test(local) && local.charAt(0) !== '.' && local.charAt(local.length - 1) !== '.' && local.indexOf('..') < 0;
    var valid = localOk && GIFT_DOMAIN.test(dom);
    var fixed = dom.replace(/\s+/g, '').replace(/,/g, '.').replace(/\.{2,}/g, '.').replace(/^\.+|\.+$/g, '');
    var parts = fixed.split('.');
    var end = parts.length > 1 ? parts[parts.length - 1] : '';
    var i;
    if (GIFT_ENDS[end]) { parts[parts.length - 1] = GIFT_ENDS[end]; fixed = parts.join('.'); }
    if (parts.length === 1) {
      for (i = 0; i < GIFT_BIG.length; i++) if (GIFT_BIG[i].split('.')[0] === fixed) { fixed = GIFT_BIG[i]; break; }
    }
    if (GIFT_BIG.indexOf(fixed) < 0) {
      var nm = fixed.split('.')[0], tl = fixed.slice(nm.length + 1);
      var most = nm.length >= 6 ? 2 : (nm.length >= 4 ? 1 : 0);
      var best = null, bestD = 99;
      for (i = 0; i < GIFT_BIG.length; i++) {
        var bn = GIFT_BIG[i].split('.')[0], bt = GIFT_BIG[i].slice(bn.length + 1);
        var dd = giftDist(fixed, GIFT_BIG[i]);
        var near = (bn === nm && fixed.split('.').length === 2) || dd <= most ||
          (nm.length === 3 && bt === tl && bn.split('').sort().join('') === nm.split('').sort().join(''));
        if (near && dd < bestD) { bestD = dd; best = GIFT_BIG[i]; }
      }
      if (best) fixed = best;
    }
    return { valid: valid, fix: (fixed !== dom && localOk && GIFT_DOMAIN.test(fixed)) ? local + '@' + fixed : null };
  }
  function giftEditor() {
    if (window.__vcGiftEditor) return;
    window.__vcGiftEditor = true;
    function each(fn) { Array.prototype.forEach.call(document.querySelectorAll('[data-vc-gift][data-vc-bound]'), fn); }
    document.addEventListener('shopify:block:select', function (e) {
      var id = e.detail && e.detail.blockId;
      window.__vcGiftSel = id;
      each(function (b) { if (id && b.getAttribute('data-vc-gift-block') === id && b.__vcOpen) b.__vcOpen(); });
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var id = e.detail && e.detail.blockId;
      if (window.__vcGiftSel === id) window.__vcGiftSel = null;
      each(function (b) { if (id && b.getAttribute('data-vc-gift-block') === id && b.__vcClose) b.__vcClose(); });
    });
    /* a section that is re-rendered or removed takes its card along */
    document.addEventListener('shopify:section:unload', function (e) {
      var sid = e.detail && e.detail.sectionId;
      each(function (b) {
        if (sid && b.getAttribute('data-vc-gift-section') !== sid) return;
        if (b.parentNode) b.parentNode.removeChild(b);
        document.documentElement.classList.remove('vc-gift-open');
      });
    });
  }
  function bindGift() {
    var box = document.querySelector('.vc [data-vc-gift]:not([data-vc-bound])');
    if (!box) return;
    box.setAttribute('data-vc-bound', '1');
    var root = box.closest('.vc');
    /* where the sign-up leads: back to this page with the kit and the code in
       the cart drawer (as on the product page), or straight into the checkout */
    var mode = (root && root.getAttribute('data-vc-gift-target')) || 'drawer';
    var design = !!(window.Shopify && Shopify.designMode);
    /* one card at a time: an earlier render of it goes */
    Array.prototype.forEach.call(document.querySelectorAll('[data-vc-gift][data-vc-bound]'), function (old) {
      if (old !== box && old.parentNode) old.parentNode.removeChild(old);
    });
    document.documentElement.classList.remove('vc-gift-open');
    if (root) floatWrap(root).appendChild(box);
    if (design) giftEditor();
    var card = box.querySelector('.gift-card');
    var form = box.querySelector('form');
    var input = box.querySelector('input[type="email"]');
    var err = box.querySelector('.gift-err');
    var btn = box.querySelector('.gift-btn');
    var tab = box.querySelector('[data-vc-gift-open]');
    var blockId = box.getAttribute('data-vc-gift-block') || '';
    var code = (box.getAttribute('data-vc-gift-code') || '').trim();
    var variant = box.getAttribute('data-vc-gift-variant');
    var delay = parseInt(box.getAttribute('data-vc-gift-delay'), 10);
    var days = parseInt(box.getAttribute('data-vc-gift-days'), 10);
    if (!(delay >= 0)) delay = 240;
    if (!(days > 0)) days = 30;
    var KEY = 'vcGift:' + (code || 'gift').toLowerCase();
    function sget(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
    function sset(store, k, v) { try { window[store].setItem(k, v); } catch (e) {} }
    function sdel(store, k) { try { window[store].removeItem(k); } catch (e) {} }
    /* back from Shopify's robot check with this form's data? */
    var again = false;
    try {
      var q = new URLSearchParams(window.location.search);
      var fk = q.get('form_key');
      if (form && fk && q.get('form_type') === 'customer') {
        var saved = JSON.parse(sget('sessionStorage', fk) || 'null');
        again = !!(saved && String(saved.action || '').indexOf(form.id) >= 0);
      }
    } catch (e) {}
    /* or back from Shopify with the address refused? The page then shows
       the form's errors and carries this form's anchor */
    var failed = !!form && !!box.querySelector('[data-vc-gift-failed]') && window.location.hash === '#' + form.id;
    if (again || failed) sdel('localStorage', KEY + ':done');
    var done = parseInt(sget('localStorage', KEY + ':done'), 10);
    if (!design && done && (Date.now() - done) < days * 864e5) return;
    var route = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (route.charAt(route.length - 1) !== '/') route += '/';
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var overlays = themeOverlays();
    var timer = 0, opener = null;
    function captcha() {
      var c = window.Shopify && Shopify.captcha;
      return c && typeof c.protect === 'function' ? c : null;
    }
    function bound() { return !!form && form.hasAttribute('data-hcaptcha-bound'); }
    /* wire up Shopify's spam protection, unless it is already on its way */
    function arm() {
      var c = captcha();
      if (design || !c || !form || bound() || form.dataset.cptcha) return;
      try { c.protect(form); } catch (e) {}
    }
    function lock(on) { document.documentElement.classList.toggle('vc-gift-open', on); }
    /* the heading on a phone: when it wraps but would fit on one line at no
       less than 80% of its size, it gets the size that fits */
    var head = box.querySelector('.gift-h');
    var phone = window.matchMedia ? matchMedia('(max-width: 640px)') : null;
    function fitHead() {
      if (!head) return;
      head.style.fontSize = '';
      if (!phone || !phone.matches || !box.classList.contains('is-open')) return;
      var cs = getComputedStyle(head);
      var size = parseFloat(cs.fontSize);
      var line = parseFloat(cs.lineHeight) || size * 1.2;
      if (!(size > 0) || head.offsetHeight < line * 1.5) return;
      head.style.whiteSpace = 'nowrap';
      var need = head.scrollWidth;
      head.style.whiteSpace = '';
      var k = need > 0 ? head.clientWidth / need : 1;
      if (k < 1 && k >= 0.8) head.style.fontSize = (size * k * 0.985).toFixed(2) + 'px';
    }
    function open(from) {
      clearTimeout(timer);
      opener = from || null;
      box.classList.remove('is-min');
      box.classList.add('is-open');
      lock(true);
      fitHead();
      requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('in'); }); });
      if (!design) sset('sessionStorage', KEY, 'seen');
      setTimeout(function () { if (card && card.focus) card.focus({ preventScroll: true }); }, reduce ? 0 : 340);
    }
    function close() {
      box.classList.remove('in');
      lock(false);
      var fin = function () {
        box.classList.remove('is-open');
        box.classList.add('is-min');
        if (tab && opener && tab.focus) tab.focus({ preventScroll: true });
      };
      if (reduce) fin(); else setTimeout(fin, 320);
      if (!design) sset('sessionStorage', KEY, 'min');
    }
    box.__vcOpen = function () { open(); };
    box.__vcClose = function () { if (box.classList.contains('is-open')) close(); };
    box.hidden = false;
    Array.prototype.forEach.call(box.querySelectorAll('[data-vc-gift-close]'), function (el) {
      el.addEventListener('click', function () { close(); });
    });
    if (tab) tab.addEventListener('click', function () { open(tab); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.isConnected && box.classList.contains('is-open')) close(); });
    /* the heading is fitted again when the phone turns or the fonts arrive */
    function refit() { if (box.isConnected && box.classList.contains('is-open')) fitHead(); }
    window.addEventListener('resize', refit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
    var state = design ? null : sget('sessionStorage', KEY);
    if (design) {
      if (blockId && window.__vcGiftSel === blockId) open(); else box.classList.add('is-min');
    } else if (again || failed) {
      open();
    } else if (state === 'min' || state === 'seen') {
      box.classList.add('is-min');
    } else {
      /* not opened yet in this visit: the tab shows right away, and the
         card opens by itself after the set time on this page, unless the
         visitor opens it first. A page the browser brings back from its
         cache checks again, as the card may have been opened on another
         page meanwhile or the address sent. */
      box.classList.add('is-min');
      var tries = 0;
      var fire = function () {
        var st = sget('sessionStorage', KEY), signed = parseInt(sget('localStorage', KEY + ':done'), 10);
        if (st === 'min' || st === 'seen' || (signed && (Date.now() - signed) < days * 864e5)) return;
        if (overlayOpen(overlays) && tries++ < 12) { timer = setTimeout(fire, 5000); return; }
        open();
      };
      timer = setTimeout(fire, delay * 1000);
    }
    /* the pictures: a snap row that follows a finger swipe, the numbered
       buttons under it, the arrows and the arrow keys */
    var slides = box.querySelector('[data-gift-slides]');
    if (slides && slides.children.length > 1) {
      var dots = Array.prototype.slice.call(box.querySelectorAll('.gift-dots button'));
      var n = slides.children.length;
      var cur = function () { return Math.min(n - 1, Math.max(0, Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)))); };
      var go = function (i) { i = (i + n) % n; slides.scrollTo({ left: i * slides.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
      slides.addEventListener('scroll', function () {
        var i = cur();
        dots.forEach(function (d, j) {
          d.classList.toggle('on', j === i);
          if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }, { passive: true });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
      var prev = box.querySelector('[data-gift-prev]'), next = box.querySelector('[data-gift-next]');
      if (prev) prev.addEventListener('click', function () { go(cur() - 1); });
      if (next) next.addEventListener('click', function () { go(cur() + 1); });
      if (card) card.addEventListener('keydown', function (e) {
        if (e.target && e.target.tagName === 'INPUT') return;
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur() + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur() - 1); }
      });
    }
    if (!form || !input) return;
    var back = form.querySelector('input[name="return_to"]');
    var hint = box.querySelector('[data-gift-hint]');
    var busy = false, pass = false, calm = 0, asked = '';
    function fail() {
      if (err) {
        if (err.getAttribute('data-msg')) err.textContent = err.getAttribute('data-msg');
        err.hidden = false;
      }
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }
    function calmNotes() {
      if (err) err.hidden = true;
      input.removeAttribute('aria-invalid');
      if (hint) hint.hidden = true;
      asked = '';
    }
    /* "Did you mean max@gmail.com?", the address a button that takes it */
    function suggest(addr) {
      if (!hint) return;
      hint.textContent = '';
      hint.appendChild(document.createTextNode(hint.getAttribute('data-hint-a') || ''));
      var take = document.createElement('button');
      take.type = 'button';
      take.className = 'gift-fix';
      take.textContent = addr;
      take.addEventListener('click', function () {
        input.value = addr;
        calmNotes();
        input.focus();
      });
      hint.appendChild(take);
      hint.appendChild(document.createTextNode(hint.getAttribute('data-hint-b') || ''));
      if (err) err.hidden = true;
      hint.hidden = false;
    }
    function stop(e) {
      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation(); else e.stopPropagation();
    }
    function rest() { busy = false; if (btn) btn.removeAttribute('aria-busy'); }
    /* The way back after the sign-up: this page, marked so that
       bindGiftReturn puts the kit and the code into the cart and opens the
       drawer; set to the checkout, Shopify's cart link with the kit, the
       code and the address, straight into the checkout. */
    function target(email) {
      var qty = 1;
      if (mode !== 'checkout') {
        return window.location.pathname + '?vcgift=' + encodeURIComponent(code || '') + '&vcid=' + encodeURIComponent(variant) + '&vcqty=' + qty;
      }
      var q = [];
      if (code) q.push('discount=' + encodeURIComponent(code));
      if (email) q.push('checkout%5Bemail%5D=' + encodeURIComponent(email));
      return route + 'cart/' + variant + ':' + qty + (q.length ? '?' + q.join('&') : '');
    }
    input.addEventListener('input', calmNotes);
    form.addEventListener('submit', function (e) {
      if (pass) return;
      if (busy) { stop(e); return; }
      var email = (input.value || '').trim();
      var c = giftCheck(email);
      /* a suggestion first; a well-formed address typed again as it was
         goes out on the second press */
      if (c.fix && !(c.valid && asked === email)) { stop(e); suggest(c.fix); asked = email; return; }
      if (!c.valid || !input.checkValidity()) { stop(e); fail(); return; }
      if (input.value !== email) input.value = email;
      if (hint) hint.hidden = true;
      busy = true;
      if (btn) btn.setAttribute('aria-busy', 'true');
      if (back && variant) back.value = target(email);
      if (!design) sset('localStorage', KEY + ':done', String(Date.now()));
      clearTimeout(calm);
      calm = setTimeout(rest, 12000);
      /* with the spam protection in place (or none in the shop) Shopify
         takes it from here */
      if (bound() || !captcha()) return;
      /* still loading: hold the form until it is ready, then send it the
         same way again */
      stop(e);
      arm();
      var waited = 0, sent = false;
      var send = function () {
        if (sent) return;
        sent = true;
        pass = true;
        try { if (form.requestSubmit) form.requestSubmit(btn || undefined); else form.submit(); } finally { pass = false; }
      };
      (function wait() { if (bound() || waited++ >= 30) send(); else setTimeout(wait, 150); })();
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { clearTimeout(calm); rest(); } });
  }

  /* Back from the welcome gift's sign-up: the form's return_to brings the
     visitor to this page with vcgift, vcid and vcqty in the address. The
     kit goes into the cart unless it is there already, the code joins the
     cart's discount codes, and the drawer slides in with the code shown in
     the cart's summary.
     The sign-up itself is Shopify's and done by then; the markers are taken
     off the address at once, so a reload does not add again. */
  function bindGiftReturn() {
    if (window.__vcGiftReturn) return;
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
    var code = q.get('vcgift');
    if (code === null) return;
    window.__vcGiftReturn = 1;
    var id = q.get('vcid'), qty = parseInt(q.get('vcqty'), 10);
    if (!(qty > 0)) qty = 1;
    try {
      ['vcgift', 'vcid', 'vcqty'].forEach(function (k) { q.delete(k); });
      var rest = q.toString();
      history.replaceState(null, '', window.location.pathname + (rest ? '?' + rest : '') + window.location.hash);
    } catch (e) {}
    var codes = [];
    cartGet().then(function (cart) {
      codes = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(Boolean);
      var have = (cart.items || []).some(function (it) { return String(it.variant_id) === String(id); });
      if (have || !id) return cart;
      return cartPost('cart/add.js', { items: [{ id: id, quantity: qty }] });
    }).then(function () {
      var body = { sections: cartSections() };
      if (code && codes.indexOf(code) < 0) codes.push(code);
      if (codes.length) body.discount = codes.join(',');
      return cartPost('cart/update.js', body);
    }).then(function (cart) {
      /* published as an ordinary cart update: the theme shows the applied
         code in the cart itself; published as a discount entry it would
         also open its Redeem discount panel over the cart */
      openDrawer(cart);
    }).catch(function () {});
  }

  function bind() { bindGift(); bindGiftReturn(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  /* the theme editor re-renders single sections, so re-bind on those events */
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:select', bind);
})();
